// extracted by mini-css-extract-plugin
export default {"ats-label":"style_ats-label__LokSM","atsLabel":"style_ats-label__LokSM"};